import(/* webpackMode: "eager" */ "/home/runner/work/marbles-stack/marbles-stack/apps/game-widget/src/app/global-error.tsx");
